import {
  AddressElement,
  PaymentElement,
  useElements,
  useStripe,
} from '@stripe/react-stripe-js';
import React, { useContext, useState } from 'react';
import { useQueryClient } from 'react-query';

import { BookingProviderContext } from '@/contexts/BookingProfileContext';
import { EditProfileContext } from '@/contexts/EditProfileProvider';

const CheckoutCardForm = ({
  handleSelectedPayment,
  handleToggleModal,
}: {
  handleToggleModal: () => void;
  handleSelectedPayment: (id: string) => void;
}) => {
  const { showAlert } =
    useContext(EditProfileContext) || useContext(BookingProviderContext);
  const stripe = useStripe();
  const elements = useElements();
  const queryClient = useQueryClient();

  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }
    setLoading(true);
    setErrorMessage(null);

    const { error, setupIntent } = await stripe.confirmSetup({
      elements,
      confirmParams: {
        return_url: `${window.location.origin}/account/edit?#/billing`,
      },
      redirect: 'if_required',
    });

    setErrorMessage(error?.message ?? null);

    if (!error?.message && setupIntent?.payment_method) {
      const newPaymentMethodId = setupIntent.payment_method;
      if (typeof newPaymentMethodId === 'string') {
        handleSelectedPayment(newPaymentMethodId);
      }
    }

    if (!error?.message) {
      await queryClient.invalidateQueries(['paymentMethods']);
      handleToggleModal();
      showAlert({
        type: 'success',
        title: 'Payment method added',
        description: 'Payment method was successfully added.',
      });
    }

    setLoading(false);
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{ overflow: 'visible', width: 'inherit', margin: '4px' }}
    >
      <PaymentElement />
      <AddressElement
        options={{
          mode: 'billing',
        }}
      />

      <button disabled={!stripe || loading} className='btn w-full mt-14'>
        {loading ? 'Processing...' : 'Submit'}
      </button>
      {errorMessage && (
        <div className='text-customRed mt-4'>{errorMessage}</div>
      )}
    </form>
  );
};

export default CheckoutCardForm;
